import {createFileRoute} from '@tanstack/react-router';
import {LoanAccountStatementDocumentsPage} from 'features/loans/pages/LoanAccountStatementDocumentsPage/LoanAccountStatementDocumentsPage';

export const Route = createFileRoute(
  '/_protected/home/accounts/loans/$accountId/invoices',
)({
  component: LoanAccountStatementDocumentsPage,
  staticData: {crumbKey: 'navigation.invoices'},
});
